var render = function render(_c,_vm){return _c('span',[(_vm.props.currency.toLowerCase() === 'gbp')?_c('span',[_vm._v("£")]):_vm._e(),(_vm.props.currency.toLowerCase() === 'usd')?_c('span',[_vm._v("$")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }